import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    items: {
      conferenceRooms: [],
      conferenceStands: [],
      conferenceUsers: [],
      conferenceRoomStands: [],
    },
    item: {
      conferenceUser: {},
      conferenceRoomStand: {},
      user: {},
      conferenceRoomUuid: {},
      currentConferenceRoomUuid: null,
    },
  },
  actions: {
    fetchConferenceRooms({commit}) {
      axios.get(`/webapi/conference/room`).then(({data}) => {
        commit("setConferenceRooms", data.data)
      })
    },
    fetchConferenceStands({commit}) {
      axios.get(`/webapi/conference/stand`).then(({data}) => {
        commit("setConferenceStands", data.data)
      })
    },
    fetchConferenceRoomUsers({commit, state}) {
      return axios
        .get(`/webapi/conference/user`, {
          params: {
            conference_room_uuid: state.item.conferenceRoomUuid,
          },
        })
        .then(({data}) => {
          commit("setConferenceUsers", data.data)
        })
    },
    fetchConferenceRoomStands({commit, state}) {
      axios
        .get(`/webapi/conference/room/stand`, {
          params: {
            conference_room_uuid: state.item.conferenceRoomUuid,
          },
        })
        .then(({data}) => {
          commit("setConferenceRoomStands", data.data)
        })
    },
    fetchUserByEmail({commit}, filter) {
      return axios
        .post(`/webapi/conference/user/email`, {
          email: filter.email,
        })
        .then(({data}) => {
          commit("setUser", data.data)
        })
        .catch(() => {
          commit("setUser", {})
        })
    },
    putConferenceRoomStand({commit}, data) {
      return axios.put(`/webapi/conference/room/stand/${data.conference_room_stand_uuid}`, {
        conference_user_uuid: data.conference_user_uuid,
      })
    },
    addConferenceRoomStand({commit, state}, data) {
      return axios.post(`/webapi/conference/room/stand`, {
        conference_user_uuid: data.conference_user_uuid,
        conference_room_uuid: data.conference_room_uuid,
        conference_stand_uuid: state.item.conferenceRoomStand.conference_stand_uuid,
      })
    },
    clearConferenceRoomStand({commit}, data) {
      return axios.delete(`/webapi/conference/room/stand/${data.conference_room_stand_uuid}`)
    },
  },
  mutations: {
    setConferenceRooms(state, conferenceRooms) {
      state.items.conferenceRooms = conferenceRooms
    },
    setConferenceStands(state, conferenceStands) {
      state.items.conferenceStands = conferenceStands
    },
    setConferenceUsers(state, conferenceUsers) {
      state.items.conferenceUsers = conferenceUsers
    },
    setConferenceUser(state, conferenceUser) {
      state.item.conferenceUser = conferenceUser
    },
    setUser(state, user) {
      state.item.user = user
    },
    setConferenceRoomStands(state, conferenceRoomStands) {
      state.items.conferenceRoomStands = conferenceRoomStands
    },
    setConferenceRoomStand(state, conferenceRoomStand) {
      state.item.conferenceRoomStand = conferenceRoomStand
    },
    setConferenceRoomUuid(state, conferenceRoomUuid) {
      state.item.conferenceRoomUuid = conferenceRoomUuid
    },
    setConferenceModelDescription(state, conferenceModel) {
      for (const index in state.item.conferenceRoomStand.conference_models) {
        if (conferenceModel.uuid === state.item.conferenceRoomStand.conference_models[index].uuid) {
          state.item.conferenceRoomStand.conference_models[index].description = conferenceModel.description
          state.item.conferenceRoomStand.conference_models[index].file_label = conferenceModel.file_label
        }
      }
    },
    updateConferenceFile(state, conferenceFile) {
      for (const index in state.item.conferenceRoomStand.conference_files) {
        if (conferenceFile.uuid === state.item.conferenceRoomStand.conference_files[index].uuid) {
          state.item.conferenceRoomStand.conference_files[index].file_label = conferenceFile.file_label
        }
      }
    },
    // clearCurrentConferenceRoomStand(state) {
    //   state.item.conferenceRoomStand = {}
    // },
  },
  getters: {
    getCurrentConferenceRoomStand(state) {
      return state.item.conferenceRoomStand
    },
    getConferenceRooms(state) {
      return state.items.conferenceRooms
    },
    getConferenceRoom(state) {
      return state.items.conferenceRooms.find((item) => item.uuid === state.item.conferenceRoomUuid)
    },
    getConferenceRoomUuid(state) {
      return state.item.conferenceRoomUuid
    },
    getConferenceRoomStands(state) {
      return state.items.conferenceRoomStands
    },
    getConferenceStands(state) {
      return state.items.conferenceStands
    },
    getConferenceUsers(state) {
      return state.items.conferenceUsers
    },
    getConferenceUser(state) {
      return state.item.conferenceUser
    },
    getUser(state) {
      return state.item.user
    },
    getConferenceRoomStand: (state) => (conferenceStandUuid) => {
      return state.items.conferenceRoomStands.find((item) => item.conference_stand_uuid === conferenceStandUuid)
    },
  },
})
